
export const getMyProfile = state => {
  if (state.myProfile && state.myProfile.id) {
    return state.myProfile
  } else {
    if (localStorage.getItem("profile")) {
      return JSON.parse(localStorage.getItem("profile"))
    } else {
      return null
    }
  }
}

export const getMyToken = state => {
  return state.myToken || localStorage.getItem("user-token")
}

export const getMyRefreshToken = state => {
  return state.myRefreshToken || localStorage.getItem("user-refresh-token")
}

export const getNextRefreshTime = state => {
  return state.sendNextRefreshRequestIn
}

export const getUserPermissions = state => {
  return state.userPermissions
}